import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isMiniprogram } from "./common";
import MethodsClass from "./method";
var Methods = new MethodsClass();
export var zzsdk = 'https://s1.zhuanstatic.com/common/zzapp/static/js/1.30.19/index.min.js';
export var jweixin = 'https://s1.zhuanstatic.com/common/jweixin-1.5.0.js';
export var zzwasdk = 'https://s1.zhuanstatic.com/common/zzwa/static/js/zzwasdk-v1.4.46.js';
var loadJS = function loadJS(url) {
  var asyncMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise(function (res) {
    var head = window.document.getElementsByTagName('head')[0];
    var js = window.document.createElement('script');
    js.setAttribute('type', 'text/javascript');
    asyncMode && js.setAttribute('async', 'async');
    js.setAttribute('src', url);
    js.onload = res;
    head.appendChild(js);
  });
};
export var initLoadSdk = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (!(isMiniprogram() && !window.zzwa)) {
            _context.next = 5;
            break;
          }
          _context.next = 4;
          return Promise.all([loadJS(jweixin), loadJS(zzwasdk)]);
        case 4:
          return _context.abrupt("return");
        case 5:
          if (!(Methods.isZZ() || Methods.isZlj())) {
            _context.next = 11;
            break;
          }
          if (!window.__ZZAPP__) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return");
        case 8:
          _context.next = 10;
          return loadJS(zzsdk);
        case 10:
          return _context.abrupt("return");
        case 11:
          _context.next = 17;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          return _context.abrupt("return");
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 13]]);
  }));
  return function initLoadSdk() {
    return _ref.apply(this, arguments);
  };
}();